<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ALVGAi/tc-custom/9780226488257.jpg?1737331095179" alt="This image is the cover for the book What a Philosopher Is"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What a Philosopher Is
      </h1>
      <p class="bookDescription body article font2">
        <p>The trajectory of Friedrich Nietzsche’s thought has long presented a difficulty for the study of his philosophy. How did the young Nietzsche—classicist and ardent advocate of Wagner’s cultural renewal—become the philosopher of Will to Power and the Eternal Return?<br/>  <br/> With this book, Laurence Lampert answers that question. He does so through his trademark technique of close readings of key works in Nietzsche’s journey to philosophy: <i>The Birth of Tragedy</i>, <i>Schopenhauer as Educator</i>, <i>Richard Wagner in Bayreuth</i>, <i>Human All Too Human</i>, and “Sanctus Januarius,” the final book of the 1882 <i>Gay Science.</i> Relying partly on how Nietzsche himself characterized his books in his many autobiographical guides to the trajectory of his thought, Lampert sets each in the context of Nietzsche’s writings as a whole, and looks at how they individually treat the question of what a philosopher is. Indispensable to his conclusions are the workbooks in which Nietzsche first recorded his advances, especially the 1881 workbook which shows him gradually gaining insights into the two foundations of his mature thinking. The result is the most complete picture we’ve had yet of the philosopher’s development, one that gives us a Promethean Nietzsche, gaining knowledge even as he was expanding his thought to create new worlds.<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurence Lampert
      </h2>
      
      <p class="authorDescription body article"><B>Laurence Lampert</B> is emeritus professor of philosophy at Indiana University–Purdue University Indianapolis and the author of three previous books on Nietzsche as well as <I>Leo Strauss and Nietzsche</I>, <I>How Philosophy Became Socratic</I>, and <I>The Enduring Importance of Leo Strauss</I>, also&#160;published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10893014